import { gql } from '@apollo/client';

export const leasingIncomeSchemaFragment = gql`
  fragment leasingIncomeSchema on LeasingIncomeSchema {
    id
    code
    name
    isActive
    validFrom
    validTo
    notes
    negotiationLimitsInAbsoluteValues
    isEditable
  }
`;

export const leasingIncomeSchemaDetailFragment = gql`
  fragment leasingIncomeSchemaDetail on LeasingIncomeSchemaDetail {
    id
    schemaId
    eventId
    eventName
    incomeTypeId
    incomeTypeCode
    incomeTypeName
    incomeTypeCurrencyName
    incomeTypeUseFormula
    currencyId
    currencyCode
    currencyName
    currencyValue
    currencyPercent
    minValue
    maxValue
    measuringUnitId
    measuringUnitName
    negotiationMomentId
    negotiationMomentName
    precondition
    formula
    negotiationLimits {
      id
      detailId
      orderNo
      lowerPercentLimit
      upperPercentLimit
      lowerValueLimit
      upperValueLimit
      firstApprovalUserGroups
      secondApprovalUserGroups
    }
  }
`;

export const leasingIncomeSchemaPropertyFragment = gql`
  fragment leasingIncomeSchemaProperty on LeasingIncomeSchemaProperty {
    schemaId
    propertyId
    propertyName
    propertyTypeCode
    value
  }
`;

export const leasingIncomeSchemaXPartnerFragment = gql`
  fragment leasingIncomeSchemaXPartner on LeasingIncomeSchemaXPartner {
    id
    schemaId
    partnerId
    partnerName
    partnerCode
    uniqueId
  }
`;

export const leasingIncomeSchemaXGroupFragment = gql`
  fragment leasingIncomeSchemaXGroup on LeasingIncomeSchemaXGroup {
    id
    schemaId
    groupId
    groupName
    parentGroupName
  }
`;
